import React from 'react';

const MoveAndTransformMaterialToNext = () => (
  <div>MoveAndTransformMaterialToNext</div>
);

export default MoveAndTransformMaterialToNext;
